import { render } from "./ProjectStages.vue?vue&type=template&id=230bd63d&ts=true"
import script from "./ProjectStages.vue?vue&type=script&lang=ts"
export * from "./ProjectStages.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__